"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _format = _interopRequireDefault(require("date-fns/format"));
var _isDate = _interopRequireDefault(require("date-fns/isDate"));
var _parseISO = _interopRequireDefault(require("date-fns/parseISO"));
var _reactInfiniteScroller = _interopRequireDefault(require("react-infinite-scroller"));
var _PendingIndicator = _interopRequireDefault(require("../../../components/PendingIndicator"));
var _Snack = _interopRequireDefault(require("../Notifications/Snack"));
var _constants = require("../../constants");
var _notifications = require("../../constants/notifications");
var Styled = _interopRequireWildcard(require("./styles"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BellWidget = ({
  innerRef = () => {},
  placement,
  style,
  notifications = [],
  localeData,
  loadNextNotifications,
  hasMoreNotifications,
  onReadNotification,
  seeAllAction,
  arrow
}) => {
  const theme = (0, _styledComponents.useTheme)();
  const renderNotifications = () => {
    if (!notifications.length) {
      return _react.default.createElement(Styled.PlaceholderContainer, null, _react.default.createElement(Styled.Placeholder, null, localeData.noNotifications));
    }
    return _react.default.createElement(_reactInfiniteScroller.default, {
      pageStart: 1,
      loadMore: loadNextNotifications,
      hasMore: !!hasMoreNotifications,
      threshold: 300,
      useWindow: false,
      loader: _react.default.createElement(Styled.Loader, {
        key: "infinite-loader"
      }, _react.default.createElement(_PendingIndicator.default, {
        width: 35,
        height: 10
      }))
    }, notifications.map(item => _react.default.createElement(_Snack.default, {
      key: item.ID,
      notification: item,
      target: _notifications.TARGETS.EXTERNAL,
      localeData: localeData,
      createdOn: (0, _format.default)((0, _isDate.default)(item.createdOn) ? item.createdOn : (0, _parseISO.default)(item.createdOn), localeData.dateFormat),
      isFadeIn: false,
      onHide: onReadNotification
    })));
  };
  return _react.default.createElement(Styled.BellNotifications, {
    ref: innerRef,
    "data-placement": placement,
    style: style
  }, _react.default.createElement(Styled.Container, null, _react.default.createElement(Styled.Header, null, _react.default.createElement(Styled.Title, null, localeData.notifications)), _react.default.createElement(Styled.Body, null, _react.default.createElement(Styled.NotificationsArea, null, renderNotifications()), seeAllAction && _react.default.createElement(Styled.Footer, null, _react.default.createElement(Styled.FooterAction, null, _react.default.createElement(Styled.SeeAllBtn, {
    onClick: seeAllAction
  }, localeData.seeAll), theme.name === _constants.THEMES.mds && _react.default.createElement(Styled.FooterIcon, {
    onClick: seeAllAction
  }))))), theme.name !== _constants.THEMES.mds && _react.default.createElement(Styled.Arrow, {
    ref: arrow.ref,
    style: arrow.style,
    "data-placement": placement
  }));
};
var _default = exports.default = BellWidget;